import { ColorIcon } from "src/design-system/ColorIcon";
import { type ColorIconColor } from "src/design-system/utils/colorPalette";

export const DIVIDER = "divider" as const;

type LegendProps = {
  items: LegendItem[];
};

export type LegendItem =
  | {
      color: ColorIconColor;
      name: string;
      type: "circle" | "dash";
    }
  | typeof DIVIDER;

export const Legend: React.FC<LegendProps> = ({ items }) => (
  <div className="mt-10 mb-6 flex items-center gap-1 font-inter-medium-12px">
    {items.map((item, index) =>
      item === DIVIDER ? (
        <div key={`divider-${index}`} className="h-4 w-px bg-gray-200" />
      ) : (
        <div key={item.name} className="flex items-center px-2 py-1">
          <ColorIcon color={item.color} icon={item.type} size="3xs" />
          {item.name}
        </div>
      ),
    )}
  </div>
);
